<button
  bitButton
  [bitMenuTriggerFor]="itemOptions"
  [buttonType]="buttonType"
  type="button"
  [startIcon]="!hideIcon ? 'bwi-plus' : undefined"
>
  {{ (hideIcon ? "createSend" : "new") | i18n }}
</button>
<bit-menu #itemOptions>
  <a bitMenuItem [routerLink]="buildRouterLink()" [queryParams]="buildQueryParams(sendType.Text)">
    <i class="bwi bwi-file-text" slot="start" aria-hidden="true"></i>
    {{ "sendTypeText" | i18n }}
  </a>
  <a bitMenuItem (click)="sendFileClick()" [title]="'popOutNewWindow' | i18n">
    <div class="tw-flex tw-items-center tw-gap-2">
      <i class="bwi bwi-file" slot="start" aria-hidden="true"></i>
      {{ "sendTypeFile" | i18n }}
      <app-premium-badge></app-premium-badge>
    </div>
    <span class="tw-sr-only">{{ "popOutNewWindow" | i18n }}</span>
    <i class="bwi bwi-popout tw-text-muted" slot="end" aria-hidden="true"></i>
  </a>
</bit-menu>
